module.exports = __webpack_public_path__ + "img/优惠券.0c21f186.png";